import Component from '../abstracts/Component';

export default class PrivacyUnsubscribeComponent extends Component {

  get SELECTORS() {
    return {
      applySubscriptions: '.js-apply-subscriptions-options',
      privacyList: '#updatePrivacyForm .ch-pri__privacy-list',
      updatePrivacyForm: '#updatePrivacyForm',
      modalOk: '.my-account-unsubscribe-modal .privacy-ok',
      modalKo: '.my-account-unsubscribe-modal .privacy-ko',
      conditionInput: '.second-condition input',
    };
  }

  constructor() {
    super();
    this.applySubscriptions = document.querySelector(this.SELECTORS.applySubscriptions);
    this.privacyLists = document.querySelectorAll(this.SELECTORS.privacyList);
    this.updatePrivacyForm = document.querySelector(this.SELECTORS.updatePrivacyForm);
    this.modalOk = document.querySelector(this.SELECTORS.modalOk);
    this.modalKo = document.querySelector(this.SELECTORS.modalKo);
  }

  initFormUnsubscribe() {
    let ctx = this;

    ctx.showButtonApply();

    this.applySubscriptions.addEventListener('click.fu', function (e) {
      e.preventDefault();
      var err = true;

      this.privacyLists.forEach((el, index) => {
        var currNL_el = el.querySelectorAll("input[name='currentProfiling[" + index + "].newsletter']")[0];
        var currPR_el = el.querySelectorAll("input[name='currentProfiling[" + index + "].profiled']")[0];

        if (currNL_el.checked || currPR_el.checked) {
          err = false;
          return false;
        }
      });
      ctx.$emit(ctx.$customEvents.LOADER_EVENTS.showLocal, {
        button: this,
      });
      this.updatePrivacyForm.submit();
      return true;

    });
  }

  resetRadiobx(){
    //only for marella cause CollapseComponent.js develop
    const inputs = [...this.updatePrivacyForm].filter(input => input.dataset.postage === 'postage');
    inputs.forEach(i => {
      if (i.attributes.checked && i.attributes.checked.value === 'checked') {
        i.checked = true;
      } else {
        i.checked = false;
      }
    })
  }

  optionNewsletter() {
    let self = this;
    // Attach click listener to condition inputs inside privacy list
    const inputs = document.querySelectorAll(
      `${this.SELECTORS.privacyList} ${this.SELECTORS.conditionInput}`
    );
    inputs.forEach((input) => {
      input.addEventListener('click', () => {
        const secondCondition = input.closest('.second-condition');
        if (!secondCondition) return;
        const selectEl = secondCondition.querySelector('select');
        const textareaEl = secondCondition.querySelector('textarea');
        const showSelectEl = secondCondition.querySelector('.show-select');
        const formTextareaEl = secondCondition.querySelector('.form-textarea');
        if (input.value === 'false') {
          // Show the select field
          selectEl?.classList.add('active');
          showSelectEl?.classList.remove('--hidden');
        } else {
          // Reset and hide fields
          if (selectEl) selectEl.value = '';
          if (textareaEl) textareaEl.value = '';
          selectEl?.classList.remove('active');
          showSelectEl?.classList.add('--hidden');
          formTextareaEl?.classList.add('--hidden');
        }
        // Emit update event to refresh height
        self.$emit(self.$customEvents.COLLAPSE_EVENTS.update, {
          extraDiv: secondCondition,
        });
        // Show apply button
        self.showButtonApply();
      });
    });
    // Initialize select logic
    self.updateSelect(self);
  }

  updateSelect(component) {
    component.privacyLists.forEach((privacyTab) => {
      const selectEl = privacyTab.querySelector('.select-box select');
      const secondCondition = privacyTab.querySelector('.second-condition');
      const textareaEl = privacyTab.querySelector('.form-textarea textarea');
      const formTextareaEl = privacyTab.querySelector('.form-textarea');
      // Ensure selectBox exists before proceeding
      if (!selectEl || !secondCondition) return;
      // Handle select change
      selectEl.addEventListener('change', () => {
        const selectedValue = selectEl.value;
        if (selectedValue === 'UNS_5') {
          formTextareaEl?.classList.remove('--hidden');
        } else {
          // Reset textarea and hide it
          if (textareaEl) textareaEl.value = '';
          formTextareaEl?.classList.add('--hidden');
        }
        // Emit layout update
        component.$emit(component.$customEvents.COLLAPSE_EVENTS.update, {
          extraDiv: secondCondition,
        });
        // Show the apply button
        component.showButtonApply();
      });
      // Initial state: show apply button
      component.showButtonApply();
    });
  }

  selectFreeText() {
    const self = this;
    const textareas = document.querySelectorAll(`${this.SELECTORS.updatePrivacyForm} .form-textarea textarea`);
    textareas.forEach(function(textarea) {
      textarea.addEventListener('keyup', function () {
        self.showButtonApply();
      });
    });
  }

  showButtonApply() {
    let count = 0;
    this.privacyLists.forEach((privacyTab, index) => {
      let _this = privacyTab;
      // take input values
      let selectValue = _this.querySelectorAll('select')[0].value;
      const textAreas = _this.querySelectorAll('textarea');
      let freeTextValue = false;
      if(textAreas && textAreas.length){
        freeTextValue = textAreas[0].value.trim() === '';
      }
      // if i select "other" and the textarea is empty, i disable the button
      if (_this.querySelector('select').classList.contains('active') && (selectValue == '' || (selectValue == 'UNS_5' && freeTextValue))) {
        count += 1;
        this.applySubscriptions.setAttribute('disabled', 'true');
      }
      // if the select is not chosen, i remove the name
      if (selectValue == '') {
        _this.querySelector('select').removeAttribute('name');
      } else {
        _this.querySelector('select').setAttribute('name', 'currentProfiling[' + index + '].reason');
      }
    });
    // if no active select or textarea, i disable the submit
    if (count == 0) {
      this.applySubscriptions.removeAttribute('disabled');
    }
  }

  render() {
    this.log("Rendering...");
    this.modalOk.addEventListener('click.pok', function () {
      this.updatePrivacyForm.append("<input type='hidden' name='delete-profile' value='delete-profile'/>");
      document.querySelector('#updatePrivacyForm, #recallForm').submit();
      document.querySelector('.vex-close').click();
    });

    this.modalKo.addEventListener('click.pko', function () {
      document.querySelector('.vex-close').click();
    });

    this.resetRadiobx();
    this.initFormUnsubscribe();
    this.optionNewsletter();
    this.selectFreeText();
  }
}
